import React, { useState } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';

const WhatsAppFloat = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const whatsappNumber = "+31684555130"; // Replace with your number
  
  const handleWhatsAppClick = () => {
    const message = "Hello! I have a question about your services.";
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      {/* Backdrop when expanded */}
      {isExpanded && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
          onClick={() => setIsExpanded(false)}
        />
      )}

      {/* Main WhatsApp Float */}
      <div className="fixed bottom-6 right-6 z-50">
        {/* Expanded Card */}
        <div className={`
          absolute bottom-full right-0 mb-4 w-72 bg-white rounded-lg shadow-2xl transform transition-all duration-300 origin-bottom-right
          ${isExpanded ? 'scale-100 opacity-100' : 'scale-95 opacity-0 pointer-events-none'}
        `}>
          <div className="p-4">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-2">
                <FaWhatsapp className="text-green-500 text-2xl" />
                <span className="font-semibold text-gray-800">Chat with Us</span>
              </div>
              <button 
                onClick={() => setIsExpanded(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <FaTimes />
              </button>
            </div>
            
            <p className="text-gray-600 text-sm mb-4">
              Hey there! 👋 Have a question? Message us for quick support.
            </p>
            
            <button
              onClick={handleWhatsAppClick}
              className="w-full bg-green-500 text-white py-2 px-4 rounded-lg hover:bg-green-600 transition-colors flex items-center justify-center space-x-2"
            >
              <FaWhatsapp className="text-xl" />
              <span>Start Chat</span>
            </button>
          </div>
        </div>

        {/* Float Button */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={`
            group flex items-center justify-center w-14 h-14 bg-green-500 rounded-full shadow-lg 
            hover:bg-green-600 transition-all duration-300 transform hover:scale-110
            ${isExpanded ? 'scale-110 bg-green-600' : ''}
          `}
        >
          {isExpanded ? (
            <FaTimes className="text-white text-2xl" />
          ) : (
            <FaWhatsapp className="text-white text-3xl" />
          )}

          {/* Tooltip - Only show when not expanded */}
          {!isExpanded && (
            <div className="absolute bottom-full right-0 mb-2 w-auto">
              <div className="bg-black text-white text-sm py-1 px-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                Chat with us
                <div className="absolute bottom-0 right-4 w-2 h-2 bg-black transform rotate-45 translate-y-1"></div>
              </div>
            </div>
          )}
        </button>
      </div>
    </>
  );
};

export default WhatsAppFloat;